// removed by extract-text-webpack-plugin
module.exports = {"mounting-node":"nrk-datasettsok-mounting-node","mountingNode":"nrk-datasettsok-mounting-node","root":"nrk-datasettsok-root"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/App.css
// module id = 83
// module chunks = 0